import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  Button,
  Alert,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from "@mui/material";
import {
  getAnswersOfUser,
  saveAnswers,
} from "../../../services/rest/users/medicalQuestions";
import { handleError } from "../../../utils/handleError";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";

const PsychologyQuestionsModal = ({
  open,
  setOpen,
  setLoading,
  answers,
  setAnswers,
}) => {
  const { _id } = useSelector((state) => state.userReducer);
  const [questionsData, setQuestionsData] = React.useState({
    estresDiario: answers?.estresDiario ?? "Moderado",
    motivacion: answers?.motivacion ?? "No",
    ansiedad: answers?.ansiedad ?? "No",
    presionComp: answers?.presionComp ?? "",
    sueño: answers?.sueño ?? "",
    apoyoEmocional: answers?.apoyoEmocional ?? "No",
  });
  const [error, setError] = React.useState("");
  const onClose = () => {
    setLoading(false);
    setOpen(false);
  };
  const handleChange = (field) => (event) => {
    setQuestionsData({ ...questionsData, [field]: event.target.value });
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      setError("");

      const answersFormat = {
        section: "psicologo",
        userAnswers: questionsData,
      };
      await saveAnswers(answersFormat);
      const responseAnswers = await getAnswersOfUser(_id);
      // console.log("responses", responseAnswers);
      setAnswers(responseAnswers ?? {});
      setLoading(false);
      toast.success("Se guardaron con éxito sus respuestas");
      onClose();
    } catch (error) {
      const { message } = handleError(error);
      toast.error(
        `En estos momentos no se pudo guardar sus respuestas. \n ${message}`
      );
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={() => onClose(false)} maxWidth="xs" fullWidth>
      <DialogTitle>Información Psicológica</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={3} sx={{ pt: 2 }}>
          {error && (
            <Grid item xs={12}>
              <Alert severity="error">{error}</Alert>
            </Grid>
          )}

          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel>Nivel de estrés diario</InputLabel>
              <Select
                value={questionsData.estresDiario}
                onChange={handleChange("estresDiario")}
                label="Nivel de estrés diario"
              >
                <MenuItem value="Bajo">Bajo</MenuItem>
                <MenuItem value="Moderado">Moderado</MenuItem>
                <MenuItem value="Alto">Alto</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="¿Te sientes motivado para entrenar regularmente?"
              value={questionsData.motivacion}
              onChange={handleChange("motivacion")}
              multiline
              rows={2}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="¿Has experimentado ansiedad o depresión en el pasado?"
              value={questionsData.ansiedad}
              onChange={handleChange("ansiedad")}
              multiline
              rows={3}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="¿Cómo manejas la presión en competencias o entrenamientos?"
              value={questionsData.presionComp}
              onChange={handleChange("presionComp")}
              multiline
              rows={3}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="¿Duermes bien? (Horas promedio)"
              type="number"
              value={questionsData.sueño}
              onChange={handleChange("sueño")}
              inputProps={{ step: "0.5", min: 0, max: 24 }}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="¿Tienes apoyo emocional o redes de apoyo? (Familia, amigos, grupos)"
              value={questionsData.apoyoEmocional}
              onChange={handleChange("apoyoEmocional")}
              multiline
              rows={3}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose()} variant="outlined" color="white">
          Cancelar
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          sx={{ backgroundColor: "#e7ef7d" }}
        >
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PsychologyQuestionsModal;
